import React from "react";

const RoomConfigServices = ({ services, number, register, isExtra }) => {
  const refName = isExtra
    ? `extra_room_configs.${number}.service`
    : `room_configs.${number}.service`;
  return (
    <div className="rooms-var__item mb-2">
      {/* <h4>{I18n.t(`js.order.services.room${number == "one" ? 1 : 2}`)}</h4> */}
      <div className="meal_wrapper form-check">
        <input
          type="radio"
          id={`term_service-${number}`}
          className="form-check-input service_radio"
          value={undefined}
          defaultChecked={true}
          {...register(refName)}
        />
        <label htmlFor={`term_service-${number}`} className="form-check-label">
          <span className="label-title">
            {I18n.t("js.order.services.standard")}
          </span>
          <span className="label-price">
            <em>{I18n.t("js.order.included")}</em>
          </span>
        </label>
        <div className="clearfix" />
      </div>
      {services.map((service) => {
        return (
          <div className="form-check" key={service.id}>
            <input
              type="radio"
              className="form-check-input service_radio"
              id={`${refName}.${service.id}`}
              value={service.id}
              defaultChecked={false}
              {...register(refName)}
            />
            <label
              className="form-check-label"
              htmlFor={`${refName}.${service.id}`}
            >
              <span className="label-title">{service.type}</span>
              <span className="label-price">
                {service.required ? (
                  <em>{I18n.t("js.order.included")}</em>
                ) : (
                  <strong>
                    {service.price} / {I18n.t("js.order.room")}
                  </strong>
                )}
              </span>
            </label>
            <div className="clearfix" />
          </div>
        );
      })}
    </div>
  );
};

export default RoomConfigServices;
